module.exports = "/dist/9405e78785a55cf0e4ea7669d4616ea9.woff";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-400italic.woff
// module id = 122
// module chunks = 0